import PCMRepository from '@/data/PCMRepository.js'
import OpointRepository from '@/data/OpointRepository.js'

const repositories = {
    pcm: PCMRepository,
    opoint: OpointRepository
}

export const RepositoryFactory = {
    get: name => repositories[name]
}
